<template>
  <div id="wt-form-search">
    <div id="wt-loading" :class="{'wt-loading-show': showLoading}">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
    <!-- -TOOLBARS -->
    <div id="wt-form-search-header">
      <div class="wts-search-toolbars">
        <!-- LEFT -->
        <div class="wts-search-toolbars-left">
          <!-- BACK -->
          <b-button
            id="btnBack"
            size="sm"
            pill
            variant="primary"
            class="mx-2 wts-search-toolbar-btn"
            :disabled="backDisable"
            @click="back"
          >
            <i class="fas fa-arrow-left mx-2"></i>
          </b-button>
          <p>
            {{title}}
            <span v-if="grid == 2">{{this.objItemData.description}}</span>
          </p>
        </div>
        <div class="wts-search-toolbars-right">
          <!-- EXIT -->
          <b-button id="btnClose" pill size="sm" variant="light" class="mx-2" @click="close">
            <i class="fas fa-times"></i>
          </b-button>
        </div>
      </div>
    </div>

    <div id="wt-form-search-main">
      <!-- VIEW SEARCH -->
      <div id="search" v-if="grid == 0">
        <!-- TITLE -->
        <p class="wt-search-title">Search.</p>
        <!-- BUTTON -->
        <b-input-group>
          <b-form-input
            id="search_input"
            v-model="search_key"
            required
            @keypress.prevent.stop.enter="list(search_key)"
          />
          <template v-slot:append>
            <b-input-group-text
              v-if="search_key"
              class="clear-search"
              @click="search_key = ''"
            >&times;</b-input-group-text>
            <b-button variant="primary" @click="list(search_key)">
              <i class="fa fa-search"></i>
            </b-button>
          </template>
        </b-input-group>
        <!-- LEGEND -->
        <p class="wt-search-legend">Search documentations by keywords</p>
      </div>

      <!-- VIEW RESULTS -->
      <div id="results" v-if="grid == 1">
        <div class="wt-search-result" v-for="(item, index) in objItems" :key="'list_result_'+index">
          <img
            id="imgPrev"
            class="wt-search-result-image"
            alt="Image Preview"
            @click="load(item.service_doc_id)"
            :src="item.service_doc_data.image_url"
            @error="imgPreviewDefault"
          />
          <div class="wt-search-result-data">
            <p
              class="wt-search-result-title"
              @click="load(item.service_doc_id)"
            >{{item.service_doc_data.description}}</p>
            <p class="wt-search-result-url">{{item.service_doc_data.service_url}}</p>
            <div class="wt-search-result-keywords">
              <p
                class="search-key-item"
                v-for="(keyw, index) in item.service_doc_data.keywords"
                :key="index"
                @click="list(keyw)"
              >{{keyw}}</p>
            </div>
            <p
              class="wt-search-result-spec"
            >{{item.service_doc_data.business_owner}} - {{item.service_doc_data.version}}</p>
          </div>
        </div>
      </div>

      <!-- VIEW PANEL -->
      <div id="panel" v-if="grid == 2">
        <div class="wt-search-panel">
          <div class="wt-search-panel-header">
            <img
              id="imgPrev"
              class="wt-search-panel-image"
              alt="Image Preview"
              :src="objItemData.image_url"
              @error="imgPreviewDefault"
            />
            <div class="wt-search-panel-data">
              <p class="wt-search-panel-title">{{objItemData.description}}</p>
              <p
                class="wt-search-panel-spec"
              >{{objItemData.business_owner}} - {{objItemData.version}}</p>
              <div class="wt-search-result-keywords">
                <p
                  class="search-key-item"
                  v-for="(keyword, index) in service_doc_keyword_tags"
                  :key="index"
                  @click="list(keyword)"
                >{{keyword}}</p>
              </div>
            </div>
          </div>

          <div class="wt-search-panel-main">
            <div class="form-row wt-search-panel-left">
              <!-- GROUP 1 -->

              <div class="form-group col-md-12 pb-4 wt-search-panel-bb">
                <div class="wt-label-with-logo">
                  <img class="swagger-logo" src="@/assets/default/swagger.png" alt="swagger logo" />
                  <label for="service_doc_service_url">Service URL (Swagger)</label>
                </div>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-button
                      variant="primary"
                      :id="'service_doc_service_url_btn'"
                      @click="copyToClipboard('#service_doc_service_url')"
                    >
                      <i class="far fa-copy"></i>
                    </b-button>
                  </b-input-group-prepend>
                  <input
                    type="text"
                    class="form-control"
                    id="service_doc_service_url"
                    v-model.trim="objItemData.service_url"
                    readonly
                  />
                </b-input-group>
              </div>
              <!-- GROUP 2 -->

              <div class="form-group col-md-12">
                <label for="service_doc_pre_production_address_service">
                  <i class="fas fa-life-ring"></i> Pre-production Address Service
                </label>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-button
                      variant="dark"
                      :id="'service_doc_pre_production_address_service_btn'"
                      @click="copyToClipboard('#service_doc_pre_production_address_service')"
                    >
                      <i class="far fa-copy"></i>
                    </b-button>
                  </b-input-group-prepend>
                  <input
                    type="text"
                    class="form-control"
                    id="service_doc_pre_production_address_service"
                    v-model.trim="objItemData.pre_production_address_service"
                    readonly
                  />
                </b-input-group>
              </div>

              <div class="form-group col-md-12">
                <label for="service_doc_production_address_service">
                  <i class="fas fa-cogs"></i> Production Address Service
                </label>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-button
                      variant="primary"
                      :id="'service_doc_production_address_service_btn'"
                      @click="copyToClipboard('#service_doc_production_address_service')"
                    >
                      <i class="far fa-copy"></i>
                    </b-button>
                  </b-input-group-prepend>
                  <input
                    type="text"
                    class="form-control"
                    id="service_doc_production_address_service"
                    v-model.trim="objItemData.production_address_service"
                    readonly
                  />
                </b-input-group>
              </div>
            </div>
            <div class="form-row wt-search-panel-right">
              <label class="form-group col-md-12">
                <i class="fas fa-link"></i> URL Doc References:
              </label>
              <div
                class="form-group col-md-12"
                v-for="(url_doc_reference, index) in service_doc_url_doc_reference_tags"
                :key="index"
              >
                <b-input-group>
                  <b-input-group-prepend>
                    <b-button
                      variant="primary"
                      :id="'service_doc_url_doc_reference' + index + '_btn'"
                      @click="copyToClipboard('#service_doc_url_doc_reference' + index)"
                    >
                      <i class="far fa-copy"></i>
                    </b-button>
                  </b-input-group-prepend>
                  <input
                    type="text"
                    class="form-control"
                    :id="'service_doc_url_doc_reference' + index"
                    :value="url_doc_reference"
                    readonly
                  />
                </b-input-group>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- NOT FOUND -->
      <div id="not-found" v-if="grid == 404">
        <p class="mb-2">The entered keyword was not found</p>
        <b-button
          id="btnBack"
          size="sm"
          pill
          variant="primary"
          class="mx-2 wts-search-toolbar-btn"
          :disabled="backDisable"
          @click="back"
        >
          <i class="fas fa-arrow-left mx-2"></i>
          <strong class="mr-2">BACK</strong>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

export default {
  name: "ServiceDocSearch",
  components: {},

  /* COMPUTED VARIABLES */
  computed: {
    showGrid() {
      return this.$store.state.layout.showGrid;
    },
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
    objShared() {
      return this.$store.state.objShared;
    },
    objSelected() {
      return this.$store.state.objSelected;
    },
    action() {
      return this.$store.state.action;
    }
  },

  data: function() {
    return {
      /* Controls */
      urlServices: "streamline-ds/api/internal/service-doc",
      primary_key: "service_doc_id",

      /* Objects Page */
      objItem: {},
      objItemData: {},
      objRowSelected: {},
      nameObjData: "service_doc_data",
      requiredEndDt: true,

      showLoading: false,

      /* Result */
      objItems: [],
      /* Tags Entry */
      service_doc_keyword_tags: [],
      service_doc_url_doc_reference_tags: [],

      /* Navigate */
      /*
        GRID:
        0 - Search Title
        1 - Results List
        2 - Documentation
      */
      grid: 0, // Atual Page Level
      search_key: "", // Key Searched
      backDisable: true, // Back Button Control
      title: "Search." // Page Title
    };
  },
  methods: {
    back() {
      switch (this.grid) {
        case 404:
          this.grid = 0;
          this.backDisable = true;
          break;
        case 2:
          this.grid = 1;
          this.backDisable = false;
          break;
        case 1:
          this.grid = 0;
          this.backDisable = true;
          break;
        default:
        /* none */
      }
    },
    close() {
      this.$router.push({ name: "home" });
    },
    /* Array Converter */
    stringToArray(input) {
      var adapt = String(input).replace("[", "");
      adapt = adapt.replace("]", "");
      adapt = adapt.replace(/'/g, "");
      adapt = adapt.replace(/"/g, "");
      adapt = adapt.split(",");
      return adapt;
    },
    /* Image default url */
    imgPreviewDefault(event) {
      event.target.src = require("@/assets/default/preview_img.png");
    },
    /* Copy To Clipboard */
    copyToClipboard(id) {
      let CodeToCopy = document.querySelector(id);
      let CodeToCopyBtn = document.querySelector(id + "_btn");
      CodeToCopy.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "Copyed" : "Error";
        var className = successful ? "btn-success" : "btn-danger";
        var classLst = CodeToCopyBtn.classList.value;

        CodeToCopyBtn.classList.value = "btn " + className;
        var btnContent = CodeToCopyBtn.innerHTML;

        CodeToCopyBtn.innerHTML = msg;
        CodeToCopyBtn.disabled = true;

        setTimeout(() => {
          CodeToCopyBtn.innerHTML = btnContent;
          CodeToCopyBtn.classList.value = classLst;
          CodeToCopyBtn.disabled = false;
        }, 1000);
      } catch (err) {
        alert("Oops, unable to copy");
      }
    },

    /* Load data By Keywords */
    list(keyword) {
      if (!keyword || keyword == "") {
        this.grid = 0;
        this.backDisable = true;
      } else {
        this.showLoading = true;
        this.backDisable = false;
        this.search_key = keyword;
        this.objItems = [];
        keyword = { keyword: keyword };

        if (this.urlServicesStore === this.urlServices) {
          const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find-all-by-keyword`;
          axios.post(url, keyword).then(res => {
            this.objItems = res.data;
            this.showLoading = false;
            if (this.objItems[0].service_doc_id) {
              this.grid = 1;
            } else {
              this.grid = 404;
            }
          });
        } else {
          this.grid = 404;
        }
      }
    },
    /* Load data By ID */
    load(doc_id) {
      this.showLoading = true;
      const param = {};
      param[`${this.primary_key}`] = doc_id;
      const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find/`;

      axios.post(url, param).then(res => {
        this.objItem = res.data[0];
        this.objItemData = this.objItem[`${this.nameObjData}`];
        this.$store.commit("setShowLoading", false);
        /* Data Tratament */
        this.service_doc_keyword_tags = "";
        this.service_doc_url_doc_reference_tags = "";
        this.service_doc_image_url = "";
        /* Convert */
        this.service_doc_keyword_tags = this.stringToArray(
          this.objItemData.keywords
        );
        this.service_doc_url_doc_reference_tags = this.stringToArray(
          this.objItemData.url_doc_references
        );
        this.service_doc_image_url = this.objItemData.image_url;

        /* Set Panel to Documentation */
        if (this.objItem.service_doc_id) {
          this.grid = 2;
        } else {
          this.grid = 404;
        }
        this.showLoading = false;
      });
    },
    titleAtt() {
      switch (this.grid) {
        case 2:
          this.title = "Search: " + this.search_key + " > ";
          break;
        case 1:
          this.title = "Search: " + this.search_key;
          break;
        default:
          this.title = "Search.";
      }
    }
  },
  watch: {
    created() {
      this.$store.commit("setTypeLayout", 2);
      this.search_key = "";
      this.grid = 0;
    },
    /* Title change */
    grid() {
      this.titleAtt();
    },
    search_key() {
      this.titleAtt();
    }
  }
};
</script>

<style>
</style>
